export default __webpack_public_path__ + "media/media/step3_tryBugHerd-b4b042d3.mp4";